import { useEffect, useState } from 'react';
import { useClient } from 'jsonapi-react';
import moment from 'moment';

// Próxima aula ao vivo do professor. Busca no mesmo endpoint do calendário da
// dashboard (/events, por mês), a partir de hoje até o fim do mês atual. Só
// quando isso não encontra nada — ex.: hoje é dia 28 e não há mais aula esse
// mês — busca uma única vez o mês seguinte; se também não achar nada ali, não
// encadeia para outro mês.
export function useNextLiveClass() {
  const client = useClient();
  const [nextLiveClass, setNextLiveClass] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchLiveClasses = async (initialDate, finalDate) => {
      const response = await client.request(`/events?filter[date_between][initial]=${initialDate}&filter[date_between][final]=${finalDate}`);
      return (response.data || []).map(({ id, type, attributes }) => ({ id, type, ...attributes })).filter(event => event.type === 'live-classroom');
    };

    const earliestUpcoming = liveClasses => liveClasses.filter(liveClass => moment(liveClass['initial-date']).isAfter(moment())).sort((a, b) => moment(a['initial-date']).diff(moment(b['initial-date'])))[0];

    const findNextLiveClass = async () => {
      try {
        const today = moment();
        const currentMonthLiveClasses = await fetchLiveClasses(today.format('YYYY-MM-DD'), today.clone().endOf('month').format('YYYY-MM-DD'));

        let candidate = earliestUpcoming(currentMonthLiveClasses);

        if (!candidate) {
          const nextMonth = today.clone().add(1, 'month');
          const nextMonthLiveClasses = await fetchLiveClasses(nextMonth.clone().startOf('month').format('YYYY-MM-DD'), nextMonth.clone().endOf('month').format('YYYY-MM-DD'));
          candidate = earliestUpcoming(nextMonthLiveClasses);
        }

        if (isMounted) setNextLiveClass(candidate || null);
      } catch (e) {
        console.error(e);
        if (isMounted) setNextLiveClass(null);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    findNextLiveClass();

    return () => {
      isMounted = false;
    };
  }, []);

  return { nextLiveClass, loading };
}
